<div class="db-main">
  <app-system-updates-panel></app-system-updates-panel>

  <!--DASHBOARD FOR COMPANY-->
  @if (!isAdmin || loggedAsCompany) {
    <div class="inner-content botMargin">
      @if (!loggedAsCompany) {
        <h3>{{ currentAuth?.administrator }}</h3>
      } @else {
        <div>
          You logged As Company: <b>{{ adminLoggedAsCompany.company }}</b>
        </div>
        <div>
          Title: <b>{{ adminLoggedAsCompany.title }}</b>
        </div>
        <div>
          Administrator: <b>{{ adminLoggedAsCompany.administrator }}</b>
        </div>
        <div>
          Email: <b>{{ adminLoggedAsCompany.email }}</b>
        </div>
        <div>
          Phone: <b>{{ adminLoggedAsCompany.phone }}</b>
        </div>
        <a (click)="logout()">Log Out</a>
      }
      <nz-divider></nz-divider>
      @if (inited && !loading) {
        <nz-row [nzGutter]="16">
          <nz-col [nzSpan]="6">
            <nz-statistic
              [nzValue]="(data.shows?.length || 0 | number)!"
              [nzTitle]="'Shows'"
            ></nz-statistic>
            @if (!isAdmin) {
              <button nz-button nzType="primary" routerLink="/vendor/shows/add">
                Add New Show
              </button>
            }
            @if (!isAdmin || loggedAsCompany) {
              <div>
                <nz-divider></nz-divider>
                <app-dashboard-details
                  category="Shows"
                  [items]="data.shows"
                ></app-dashboard-details>
              </div>
            }
          </nz-col>

          <nz-col [nzSpan]="6">
            <nz-statistic
              [nzValue]="(data.attractions?.length || 0 | number)!"
              [nzTitle]="'Attractions'"
            ></nz-statistic>
            @if (!isAdmin) {
              <button nz-button nzType="primary" routerLink="/vendor/attractions/add">
                Add New Attraction
              </button>
            }
            @if (!isAdmin || loggedAsCompany) {
              <div>
                <nz-divider></nz-divider>
                <app-dashboard-details
                  category="Attractions"
                  [items]="data.attractions"
                ></app-dashboard-details>
              </div>
            }
          </nz-col>

          <nz-col [nzSpan]="6">
            <nz-statistic
              [nzValue]="(data.hotel?.length || 0 | number)!"
              [nzTitle]="'Hotels'"
            ></nz-statistic>
            @if (!isAdmin) {
              <button nz-button nzType="primary" routerLink="/vendor/hotels/add">
                Add New Hotel
              </button>
            }
            @if (!isAdmin || loggedAsCompany) {
              <div>
                <nz-divider></nz-divider>
                <app-dashboard-details
                  category="Hotel"
                  [items]="data.hotel"
                ></app-dashboard-details>
              </div>
            }
          </nz-col>

          <nz-col [nzSpan]="6">
            <nz-statistic
              [nzValue]="(data.dining?.length || 0 | number)!"
              [nzTitle]="'Dining'"
            ></nz-statistic>
            @if (!isAdmin) {
              <button nz-button nzType="primary" routerLink="/vendor/dining/add">
                Add New Dining
              </button>
            }
            @if (!isAdmin || loggedAsCompany) {
              <div>
                <nz-divider></nz-divider>
                <app-dashboard-details
                  category="Dining"
                  [items]="data.dining"
                ></app-dashboard-details>
              </div>
            }
          </nz-col>
        </nz-row>
      } @else {
        <span nz-icon nzType="loading" nzTheme="outline"></span> Loading...
      }
    </div>
  } @else {
    <!--DASHBOARD FOR ADMIN-->
    <div class="menubar">
      <nz-input-wrapper class="dashboard-search">
        <nz-radio-group
          nzInputAddonBefore
          class="m-12"
          [(ngModel)]="bar.searchBy"
          (ngModelChange)="bar.searchByHandler()"
          nzButtonStyle="solid"
        >
          <label nz-radio-button nzValue="C">Company</label>
          <label nz-radio-button nzValue="V">Vendor Name</label>
        </nz-radio-group>

        <input
          type="text"
          nz-input
          autocomplete="false"
          name="search"
          [(ngModel)]="bar.search"
          (ngModelChange)="bar.searchHandler()"
          [placeholder]="
            bar.searchPlaceholder + (bar.searchBy === 'C' ? 'Company Name' : 'Vendor Name')
          "
        />

        <span nzInputAddonAfter class="dashboard-search-actions">
          <button nz-button nzType="primary" nzSearch>
            <i nz-icon nzType="search"></i>
          </button>
          <button nz-button nzType="default" (click)="initData(true)">
            <span nz-icon nzType="redo" nzTheme="outline"></span>
          </button>
        </span>
      </nz-input-wrapper>
      <div class="filter mt15">
        <label nz-checkbox [(ngModel)]="fAAWs">
          <nz-tag nzColor="green">All as Well ({{ fAAWi }})</nz-tag>
        </label>
        <label nz-checkbox [(ngModel)]="fUs">
          <nz-tag nzColor="orange">Unfinished ({{ fUi }})</nz-tag>
        </label>
        <label nz-checkbox [(ngModel)]="fEs">
          <nz-tag nzColor="gray">Empty ({{ fEi }})</nz-tag>
        </label>
        <label nz-checkbox [(ngModel)]="fPs">
          <nz-tag nzColor="geekblue">Pending ({{ fPi }})</nz-tag>
        </label>
        <!--        <label nz-checkbox [(ngModel)]="fAcp">-->
        <!--          <nz-tag nzColor="geekblue">Active ({{fAci}})</nz-tag>-->
        <!--        </label>-->
        <label nz-checkbox [(ngModel)]="fInp">
          <nz-tag nzColor="geekblue">Archived ({{ fIni }})</nz-tag>
        </label>
        <nz-badge class="mr15" nzColor="red" nzText="Rejected"></nz-badge>
        <nz-badge class="mr15" nzColor="geekblue" nzText="Pending"></nz-badge>
        <nz-badge class="mr15" nzColor="gray" nzText="Draft"></nz-badge>
      </div>
    </div>

    <!--    K:Loading: {{loading}} <br>-->
    <!--    K:isAdmin: {{isAdmin}} <br>-->
    <!--    K:INITED: {{inited}} <br>-->
    <!--    K:DATA: {{Object.keys(adminData).length}}-->

    <!--blocks-->
    <cdk-virtual-scroll-viewport
      [itemSize]="adminDataSize"
      [style.height]="clientHeight + 'px'"
      class="scroll-details"
    >
      @if (loading) {
        <div><span nz-icon nzType="loading" nzTheme="outline"></span> Loading...</div>
      } @else {
        <div class="companies">
          <!--          <div *ngFor="let item of (adminData | dbAdminSearch:bar.search:bar.searchBy) | keyvalue">-->
          @for (
            item of adminData
              | dbAdminSearch
                : bar.search ?? ''
                : bar.searchBy
                : fAAWs
                : fUs
                : fEs
                : fPs
                : fAcp
                : fInp
              | keyvalue;
            track item.key
          ) {
            <div class="company-card">
              <div class="company-block" [ngClass]="{ inactive: item.value.active === false }">
                <!--              <nz-ribbon nzText="Inactive" nzStandalone-->
                <!--                         nzColor="orange"-->
                <!--                         style="top: 13px">-->
                <!--              </nz-ribbon>-->
                <!--STRING 1 HEADER-->
                <div class="cmp-title">
                  <div class="cmp-tag" style="width: 80px">
                    <div [hidden]="!item.value.active">
                      @if (item.value.status === 'E') {
                        <nz-tag nzColor="gray">Empty</nz-tag>
                      }
                      @if (item.value.status === 'U') {
                        <nz-tag nzColor="orange">Unfinished</nz-tag>
                      }
                      @if (item.value.status === 'P') {
                        <nz-tag nzColor="geekblue">Pending</nz-tag>
                      }
                      @if (item.value.status === 'OK') {
                        <nz-tag nzColor="green">All as Well</nz-tag>
                      }
                    </div>
                  </div>
                  <div class="cmp-name">
                    <!--                  {{item.key | titlecase}}-->
                    {{ item.value.name | titlecase }}
                  </div>
                  <div class="cmp-login">
                    <a (click)="loginAsCompany($any(item.key))" nz-tooltip="Login as this Company">
                      <span nz-icon nzType="login" nzTheme="outline"></span>
                    </a>
                  </div>
                </div>
                <!--                <div class="controls">-->
                <!--                  @if (((item.value | filtViByCategory: 'attractions')?.length ?? 0) > 0) {-->
                <!--                  <div class="bar-block">-->
                <!--                    <div>-->
                <!--                      <i class="ticon icon-attraction"></i> {{(item.value | filtViByCategory:'attractions').length}}-->
                <!--                    </div>-->
                <!--                  </div>-->
                <!--                  }-->
                <!--                  @if (((item.value | filtViByCategory: 'dining')?.length ?? 0) > 0) {-->
                <!--                  <div class="bar-block">-->
                <!--                    <div>-->
                <!--                      <i class="ticon icon-dining"></i> {{(item.value | filtViByCategory:'dining').length}}-->
                <!--                    </div>-->
                <!--                  </div>-->
                <!--                  }-->
                <!--                  @if (((item.value | filtViByCategory: 'hotels')?.length ?? 0) > 0) {-->
                <!--                  <div class="bar-block">-->
                <!--                    <div>-->
                <!--                      <i class="ticon icon-hotel"></i> {{(item.value | filtViByCategory:'hotels').length}}-->
                <!--                    </div>-->
                <!--                  </div>-->
                <!--                  }-->
                <!--                  @if (((item.value | filtViByCategory: 'shows')?.length ?? 0) > 0) {-->
                <!--                  <div class="bar-block">-->
                <!--                    <div>-->
                <!--                      <i class="ticon icon-show"></i> {{(item.value | filtViByCategory:'shows').length}}-->
                <!--                    </div>-->
                <!--                  </div>-->
                <!--                  }-->

                <!--                  <div class="bar-btn"-->
                <!--                       nz-tooltip="Login as this Company"-->
                <!--                       (click)="loginAsCompany(item.key)">-->
                <!--                    <span nz-icon nzType="login" nzTheme="outline"></span>-->
                <!--                  </div>-->
                <!--                  <div class="bar-btn"-->
                <!--                       [nz-tooltip]="((item.spoilerExpand) ? 'Hide' : 'Show') + ' Company Details'"-->
                <!--                       (click)="toggleSpoiler(item)">-->
                <!--                    <span nz-icon nzType="caret-down" nzTheme="outline"></span>-->
                <!--                  </div>-->
                <!--                </div>-->
                <!--              </div>-->

                <!--STRING 2 VENDOR-ITEM COUNTERS-->
                <div class="cmp-vi-counters">
                  @for (cat of item.value.items | catSort: true; track cat.key) {
                    <div
                      class="vi-counter"
                      [nz-tooltip]="tt"
                      [ngClass]="{
                        disabled: cat.value.items.length === 0,
                        'flag-err':
                          cat.value.flags.noAllotments ||
                          cat.value.flags.noRateLevels ||
                          cat.value.flags.noSchedules,
                      }"
                    >
                      <div class="content">
                        <i class="tripium-icon icon-{{ cat.key }}"></i> {{ cat.value.amount }}
                        <!--{{cat.value.items.length}}-->
                      </div>
                      <div class="markers">
                        @if (cat.value.markers.rejected) {
                          <div class="marker rejected"></div>
                        }
                        @if (cat.value.markers.draft) {
                          <div class="marker draft"></div>
                        }
                        @if (cat.value.markers.pending) {
                          <div class="marker pending"></div>
                        }
                      </div>
                      <ng-template #tt>
                        @if (cat.value.amount === 0) {
                          <div>No Vendor Items</div>
                        }
                        @if (cat.value.markers.pending) {
                          <div>• Exists Pending Items</div>
                        }
                        @if (cat.value.markers.rejected) {
                          <div>• Exists Rejected Items</div>
                        }
                        @if (cat.value.markers.draft) {
                          <div>• Exists Draft Items</div>
                        }
                        @if (cat.value.flags.noAllotments) {
                          <div>• Items without Allotments</div>
                        }
                        @if (cat.value.flags.noRateLevels) {
                          <div>• Items without Rate Levels</div>
                        }
                        @if (cat.value.flags.noSchedules) {
                          <div>• Items without Schedules</div>
                        }
                      </ng-template>
                    </div>
                  }
                </div>

                <div class="cmp-actions">
                  <button
                    nz-button
                    nzType="default"
                    [disabled]="item.value.names.length === 0"
                    (click)="modal.open(item.value)"
                    nzBlock
                  >
                    View Details
                  </button>
                </div>
                <!--              @if (item.value.spoilerExpand) {-->
                <!--                <div class="cmp-grid spoiler?"></div>-->
                <!--              }-->
                <!--                <div class="attractions">-->
                <!--                  <app-company-vendor-items [vis]="item.value" category="attractions">-->
                <!--                  </app-company-vendor-items>-->
                <!--                </div>-->
                <!--                <div class="dining">-->
                <!--                  <app-company-vendor-items [vis]="item.value" category="dining">-->
                <!--                  </app-company-vendor-items>-->
                <!--                </div>-->
                <!--                <div class="hotels">-->
                <!--                  <app-company-vendor-items [vis]="item.value" category="hotels">-->
                <!--                  </app-company-vendor-items>-->
                <!--                </div>-->
                <!--                <div class="shows">-->
                <!--                  <app-company-vendor-items [vis]="item.value" category="shows">-->
                <!--                  </app-company-vendor-items>-->
                <!--                </div>-->
                <!--              </div>-->
              </div>
            </div>
          }
        </div>
      }
    </cdk-virtual-scroll-viewport>
  }
</div>

<nz-modal
  [(nzVisible)]="modal.visible"
  nzWidth="1300px"
  [nzTitle]="$any(modal.title)"
  [nzFooter]="modalFooter"
  (nzOnCancel)="modal.close()"
>
  <ng-container *nzModalContent>
    <div class="modal-content">
      <div class="cmp-grid">
        <div class="shows">
          <app-company-vendor-items
            [vis]="$any(modal.data).items?.shows?.items ?? []"
            [sorted]="true"
            [addCounter]="true"
            category="shows"
          >
          </app-company-vendor-items>
        </div>
        <div class="attractions">
          <app-company-vendor-items
            [vis]="$any(modal.data).items?.attractions?.items ?? []"
            [sorted]="true"
            [addCounter]="true"
            category="attractions"
          >
          </app-company-vendor-items>
        </div>
        <div class="hotels">
          <app-company-vendor-items
            [vis]="$any(modal.data).items?.hotels?.items ?? []"
            [sorted]="true"
            [addCounter]="true"
            category="hotels"
          >
          </app-company-vendor-items>
        </div>
        <div class="dining">
          <app-company-vendor-items
            [vis]="$any(modal.data).items?.dining?.items ?? []"
            [sorted]="true"
            [addCounter]="true"
            category="dining"
          >
          </app-company-vendor-items>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="modal.close()">Close</button>
  </ng-template>
</nz-modal>
